import { createSelector } from 'reselect';
import { List, Map } from 'immutable';

import { getActiveSpreadId } from 'redux/selectors/app';
import { getOrder } from 'redux/selectors/orders';
import { getCurrentBookSpreads } from './books';

export const getCurrentDesign = state => {
  return getOrder(state).get('design', null);
};

export const getDesigns = state => {
  return state.get('designs', List());
};

export const getSpreadDimensions = createSelector([getCurrentDesign, getDesigns], (designId, designs) => {
  const design = designs.find(design => design.get('id') === designId);
  return (design ? design.get('spread') : null) || Map();
});

export const getDesignSpreads = createSelector(
  [getCurrentDesign, getDesigns, getCurrentBookSpreads],
  (designId, designs, bookSpreads) => {
    const design = designs.find(design => design.get('id') === designId);

    if (design) {
      return Map(
        bookSpreads
          .map(bookSpread => {
            const spread = design.getIn(['spreads', bookSpread.get('actualId')]);

            if (spread) {
              const newMoments = spread
                .get('moments')
                .map(moment => moment.set('id', `${moment.get('id')}.${bookSpread.get('spreadDate').getFullYear()}`));

              return [bookSpread.get('id'), spread.set('moments', newMoments)];
            }

            return [bookSpread.get('id'), design.getIn(['spreads', bookSpread.get('id')])];
          })
          .filter(spread => spread)
      );
    }

    return Map();
  }
);

export const getSpreadDesign = createSelector([getDesignSpreads, getActiveSpreadId], (designSpreads, spreadId) => {
  return designSpreads.get(spreadId, Map());
});



// WEBPACK FOOTER //
// ./app/redux/selectors/design.js